(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ui", [], factory);
	else if(typeof exports === 'object')
		exports["ui"] = factory();
	else
		root["pakhshkit"] = root["pakhshkit"] || {}, root["pakhshkit"]["ui"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition


// WEBPACK FOOTER //
// ui/webpack/universalModuleDefinition